import { render, staticRenderFns } from "./Single-Project-Detail.vue?vue&type=template&id=831dbff4&scoped=true"
import script from "./Single-Project-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Project-Detail.vue?vue&type=script&lang=js"
import style0 from "./Single-Project-Detail.vue?vue&type=style&index=0&id=831dbff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831dbff4",
  null
  
)

export default component.exports